import { action, payload } from 'ts-action';
import { AppSettings } from 'reduxStore/common/appSettings/types';

export const setAppSettings = action('[Settings] Set application settings', payload<AppSettings>());
